import Head from 'next/head';
import Link from 'next/link';
import Header from '../../components/Header';

export default function ReverseOsmosisPage() {
  const phoneNumber = "(630) 715-8829";
  const companyName = "Partners Plumbing Co.";
  const serviceName = "Reverse Osmosis Installation";
  const serviceArea = "Kane County, Geneva, Saint Charles, South Elgin";

  return (
    <>
      <Head>
        <title>{`Reverse Osmosis Installation Kane County | Water Filtration Geneva IL`}</title>
        <meta name="description" content={`Reverse osmosis installation in Kane County, Geneva, St Charles & South Elgin, IL. Professional water filtration system installation. Clean drinking water. Call ${phoneNumber} for free quote!`} />
        <meta name="keywords" content="reverse osmosis installation, water filtration Kane County, RO system Geneva IL, drinking water system, water purification Kane County, reverse osmosis Geneva" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://partnersinplumbing.com/services/reverse-osmosis" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className="min-h-screen bg-white">
        <Header currentPage="/services/reverse-osmosis" phoneNumber={phoneNumber} companyName={companyName} />

        {/* Sticky Contact Button */}
        <div className="fixed bottom-6 right-6 z-50">
          <Link 
            href="/contact" 
            className="bg-blue-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-blue-700 transition-colors font-bold text-lg animate-pulse"
          >
            Get Quote
          </Link>
        </div>

        {/* Hero Section */}
        <section className="bg-gradient-to-r from-slate-800 to-slate-900 text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Reverse Osmosis System Installation
              </h1>
              <p className="text-xl md:text-2xl text-slate-100 mb-8 max-w-3xl mx-auto">
                Professional reverse osmosis installation in {serviceArea}. Enjoy pure, clean drinking water straight from your tap.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
                <a 
                  href={`tel:${phoneNumber}`} 
                  className="bg-yellow-500 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors"
                >
                  Call Now: {phoneNumber}
                </a>
                <Link 
                  href="/contact" 
                  className="bg-white text-slate-800 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
                >
                  Get Free Quote Online
                </Link>
              </div>
              <p className="text-slate-200 text-sm">
                💧 Pure water systems | 💰 Free consultations | 🔧 Professional installation
              </p>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Benefits of Reverse Osmosis</h2>
              <p className="text-xl text-gray-600">Experience the difference pure water makes</p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                "Removes 99% of contaminants",
                "Eliminates chlorine taste and odor",
                "Reduces harmful chemicals",
                "Saves money on bottled water",
                "Environmentally friendly",
                "Improves taste of food and drinks"
              ].map((benefit, index) => (
                <div key={index} className="bg-blue-50 p-6 rounded-lg shadow-md text-center">
                  <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <div className="w-6 h-6 bg-white rounded-full"></div>
                  </div>
                  <p className="text-gray-900 font-medium">{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-slate-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Ready for Pure, Clean Water?
            </h2>
            <p className="text-xl text-slate-100 mb-8 max-w-3xl mx-auto">
              Let our experts install a reverse osmosis system in your home. Enjoy unlimited pure water for drinking, cooking, and more. For any plumbing emergencies, we also offer <Link href="/services/emergency-plumbing-service" className="text-yellow-400 hover:text-yellow-300 font-semibold underline">24/7 emergency plumber services</Link>.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href={`tel:${phoneNumber}`} 
                className="bg-yellow-500 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors"
              >
                Call Now: {phoneNumber}
              </a>
              <Link 
                href="/contact" 
                className="bg-white text-slate-800 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
              >
                Schedule Installation
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
} 